<template>
  <div>
    <div
      id="preview"
      class="preview-block preview-block--android"
      :class="{ 'preview-block--open': isOpen}"
      @click="isOpen = !isOpen"
    >
      <img
        v-if="logo"
        :src="logo" alt="logo"
        class="preview-block__logo" />
      <span v-else class="preview-block__logo"></span>
      <div class="preview-block__content">
        <h4 v-html="template.Title" class="preview-block__title"></h4>
        <img
          v-if="isOpen"
          :src="template.ImageURL"
          class="preview-block__image"
          alt="I"
        >
        <p v-html="fixedTemplate" class="preview-block__text"></p>
      </div>
      <span class="preview-block__time">12:00</span>
    </div>
  </div>
</template>

<script>
import methods from "@/components/nodes/previewMethods.js";

export default {
  name: "HuaweiPreview",
  mixins: [methods],

  data() {
    return {
      isOpen: false
    }
  }
}
</script>

<style lang="scss">
.preview-block--android {
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  padding: 9px 11px 11px 9px;
  margin: 0 38px 60px 32px;
  position: relative;
  .preview-block {
    &__logo {
      border: 1px solid #F1EEEE;
      border-radius: 50%;
      background: #66CC00;
      min-width: 37px;
      height: 37px;
      margin-right: 6px;
    }
    &__time {
      position: absolute;
      right: 20px;
      top: 7px;
      color: #929292;
      &:after {
        position: absolute;
        content: "";
        width: 4px;
        height: 4px;
        border-left: 1px solid $color_black;
        border-bottom: 1px solid $color_black;
        transform: rotate(-45deg);
        right: -13px;
        top: 3px;
      }
    }
    &__title {
      padding-right: 28px;
    }
    &__text {
      color: #929292;
      margin-top: 4px !important;
    }

    &__image {
      border-radius: 4px;
      margin-top: 10px;
      width: 100%;
    }
  }

  &.preview-block--open {
    .preview-block__title {
      margin-top: 20px;
    }
    .preview-block__logo {
      position: absolute;
      top: 5px;
      left: 5px;
      height: 20px;
      min-width: 20px;
    }
    .preview-block__time:after {
      transform: rotate(135deg);
      right: -13px;
      top: 6px;
    }
  }
}
</style>
